import axios from 'axios'
import library from '../../../utils/Library'

export const getAllSuborganizationStaffCorpEntities = async (id) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('suborganizations') +
    '/getAllSuborganizationStaffCorpEntities'

  return await axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      suborganizationId: id
    }
  })
}
